import Vue3Tour from 'vue3-tour';
import { defineNuxtPlugin, } from '#app';
import 'vue3-tour/dist/vue3-tour.css';

export default defineNuxtPlugin((nuxtApp) => {
  console.log('Initializing Vue3Tour Plugin');

  nuxtApp.vueApp.use(Vue3Tour);

  const tourInstances = {
    accountTour: null,
    adminTour: null,
  };

  nuxtApp.vueApp.config.globalProperties.$tours = tourInstances;

  const accountTour = {
    start: () => nuxtApp.vueApp.config.globalProperties.$tours?.accountTour?.start?.(),
    stop: () => nuxtApp.vueApp.config.globalProperties.$tours?.accountTour?.stop?.(),
    nextStep: () => nuxtApp.vueApp.config.globalProperties.$tours?.accountTour?.nextStep?.(),
    previousStep: () => nuxtApp.vueApp.config.globalProperties.$tours?.accountTour?.previousStep?.(),
  };

  const adminTour = {
    start: () => nuxtApp.vueApp.config.globalProperties.$tours?.adminTour?.start?.(),
    stop: () => nuxtApp.vueApp.config.globalProperties.$tours?.adminTour?.stop?.(),
    nextStep: () => nuxtApp.vueApp.config.globalProperties.$tours?.adminTour?.nextStep?.(),
    previousStep: () => nuxtApp.vueApp.config.globalProperties.$tours?.adminTour?.previousStep?.(),
  };

  nuxtApp.vueApp.provide('tours', accountTour);
  nuxtApp.provide('tours', accountTour);
  nuxtApp.vueApp.provide('adminTours', adminTour);
  nuxtApp.provide('adminTours', adminTour);

  console.log('✅ Vue3Tour plugin initialized successfully');
});
